export default __webpack_public_path__ + "static/media/payment-blank-mastercard.d3cbb1c8.svg";